import Progress from 'redux-progress';
import { HamsError } from 'modules/hams';

import selectOrderableItems from 'modules/addon/duck/selectors/orderableItems';
import selectTerm from 'modules/addon/duck/selectors/term';
import selectChosenParentOption from 'modules/addon/duck/selectors/chosenParentOption';
import selectSearchParentOption from 'modules/addon/duck/selectors/searchParentOption';
import { CHOOSE, SEARCH } from 'modules/addon/duck/model';
import * as cart from 'modules/cart';
import { CartThunk } from 'model/State';

const getParentProgress = (mode, state) => {
  if (mode === CHOOSE) return selectChosenParentOption(state);
  if (mode === SEARCH) return selectSearchParentOption(state);
  return Progress.success(null);
};

export const addToCart = (): CartThunk => (dispatch, getState) => {
  const state = getState();
  const { mode } = state.addon;

  const parentProgress = getParentProgress(mode, state);

  return Progress.all(selectOrderableItems(state), selectTerm(state), parentProgress).ifSuccess(
    async ([items, term, parent]) => {
      if (items.length > 0 && term) {
        const dcAppParentAccountId = parent?.license?.accountId;

        const result = await dispatch(
          cart.actions.add({
            newItems: items.map((item) => ({
              orderableItemId: item.orderableItemId,
              maintenanceMonths: term.months,
              renewalMonths: term.months,
              ...(dcAppParentAccountId && { dcAppParentAccountId }),
            })),
          }),
        );

        const isHamsError = result.result instanceof HamsError;

        if (result.success && !isHamsError) {
          dispatch(cart.actions.route());
        }
      }
    },
  );
};
